<template>
    <main id="mainCtrl" class="network-services">
        <div>
            <v-select
                @select="refresh"
                v-model="selectedClinicId"
                class="large network-clinics-select"
                style="max-width: 750px"
                placeholder="Выберите клинику"
                :options='clinics.map((clinic)=> {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'
            >
                <template v-slot="{ option }">
                    <div class="textarea">
                        <span>{{ option.text }}</span>
                        <div style="height: 8px;"/>
                        <small>{{ option.fullAddress }}</small>
                    </div>
                </template>
            </v-select>
        </div>

        <services-tree v-if="priceType === 'DOCTU_SERVICES'"
                       ref="servicesTree"
                       :clinic-id="selectedClinicId"
                       :is-support="isSupport"
                       :all-prices="prices"
                       :treetable="treetable"/>

        <pricelist v-else
                   ref="pricelist"
                   :has-pricelist="hasPricelist"
                   :is-medflex="isMedflex"
                   :is-network="true"
                   :clinic-id="selectedClinicId"/>
    </main>
</template>

<script>
import ServicesTree from "../../components/common/services/Tree";
import Pricelist from "../clinics/Pricelist";

export default {
    components: {
        ServicesTree,
        Pricelist,
    },
    props: {
        clinicId: {
            type: String,
            required: true,
        },
        clinics: {
            type: Array,
            required: true,
        },
        isSupport: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            selectedClinicId: this.clinicId,
            prices: {},
            treetable: [],
            categories: [],
        };
    },
    mounted: function () {
        this.refresh();
    },
    methods: {
        refresh: function () {
            let scope = this;
            setTimeout(function () {
                if (scope.priceType === 'DOCTU_SERVICES') {
                    scope.$refs.servicesTree.$refs.servicesTable.startLoadingAnimation();
                    scope.axios.post('services/getPrices', {clinic_id: scope.selectedClinicId})
                        .then((response) => {
                            scope.prices = response.data;

                            scope.axios.post('services/treetableData', {clinic_id: scope.selectedClinicId})
                                .then((response) => {
                                    scope.treetable = response.data;

                                    scope.$refs.servicesTree.$refs.servicesTable.stopLoadingAnimation();
                                });
                        });
                } else {
                    scope.$refs.pricelist.getCategories('services/getCategories').then(() => {
                        scope.$refs.pricelist.$refs.table.update();
                    });
                }
            }, 10)
        },
    },
    computed: {
        priceType: function () {
            let currentClinic = this.clinics.find(item => item.id === this.selectedClinicId);
            return currentClinic ? currentClinic.price_type : 'DOCTU_SERVICES';
        },
        hasPricelist: function () {
            let currentClinic = this.clinics.find(item => item.id === this.selectedClinicId);
            return currentClinic ? currentClinic.pricelistInfo.hasPricelist : false;
        },
        isMedflex: function () {
            let currentClinic = this.clinics.find(item => item.id === this.selectedClinicId);
            return currentClinic ? currentClinic.pricelistInfo.isMedflex : false;
        },
    },
}
</script>
<style>

</style>
